import { Injectable } from '@angular/core';
import {sound as Sound} from 'buzz';
import {TimelineTimestamp} from 'storyboard-renderer'
import {LocalStorageService} from "angular-2-local-storage";

@Injectable()
export class StoryboardRendererAudioService {

  protected audioMedia: Object;
  protected sound: Sound;
  /**
   * ha még nem megy a lejátszás, de a felhasználó már előreugrott a timeline-on,
   * akkor ebben jegyezzük meg, hogy hova kell tekerni a hang lejátszását, amikor a felhasználó
   * elindítja a play()-jel később
   */
  public cachedStartTimeSeconds: number;
  public muted = false;

  constructor(private localStorageService: LocalStorageService) {
    this.muted = !!localStorageService.get('muted');
  }

  /**
   * az az object kell ide, amiben a "sources" mező is van
   */
  public setAudioMedia(value: Object):this{
    if (this.sound){
      this.cachedStartTimeSeconds = this.sound.getTime();
    }
    this.audioMedia = value;
    this.sound = null;
    return this;
  }
  public getAudioMedia():Object{
    return this.audioMedia;
  }
  protected getSound(): Sound{
    return this.sound;
  }
  protected setSound(value: Sound):this{
    this.sound = value;
    return this;
  }
  public playing(){
    if (!this.sound){
      return false;
    }
    return !(this.sound.isEnded() || this.sound.isPaused());
  }
  public pause(){
    if (this.sound){
      this.sound.pause();
    }
  }

  public toggleMute() {
    if (this.muted) {
      this.unmute();
    } else {
      this.mute();
    }
  }

  public mute() {
    this.muted = true;
    this.localStorageService.set('muted', 1);

    if (this.sound) {
      this.sound.mute();
    }
  }

  public unmute() {
    this.muted = false;
    this.localStorageService.set('muted', 0);

    if (this.sound) {
      this.sound.unmute();
    }
  }

  public seekTo(time: TimelineTimestamp):Promise<this>{
    let self = this;
    return new Promise<this>((resolve, reject) => {
      if (!self.getAudioMedia()){
        reject("no audiomedia");
      }
      /**
       * ha van már Sound objectünk, akkor azt használjuk
       */
      self.ensureSound(self.getAudioMedia(), self.getSound())
        .then(sound => {
          let fullDurationMs = sound.getDuration() * 1000;
          let startTimeSeconds = time.as_milliseconds / 1000;

          self.setTime(startTimeSeconds);

          self.setSound(sound);
          return self;
        })
        .then(resolve)
        .catch(reject);
    });
  }
  protected setTime(value:number){
    if (this.sound){
      this.sound.setTime(value);
    }else {
      this.cachedStartTimeSeconds = value;
    }
  }
  /**
   * az az object kell ide, amiben a "sources" mező is van
   */
  public play(value?: Object):Promise<this>{
    let self = this;
    return new Promise<this>((resolve, reject) => {
     console.log("play playing", self.playing());
      if (this.playing()){
        return Promise.resolve(this);
      }
      if (value){
        /**
         * ha kaptunk audiomedia-t, akkor seteljük
         */
        self.setAudioMedia(value);
      }
      /**
      * ha van már Sound objectünk, akkor azt használjuk
      */
     console.log("play getsound", self.getSound());
     self.ensureSound(self.getAudioMedia(), self.getSound())
       .then(sound => {
         self.setSound(sound);
         if (!sound.isEnded()){
           /**
            * ha a kezdőidőpontot már elhagytuk a lejátszással,
            * akkor ne játsszuk le mégse a hangot
            */
           sound.play();
         }


         if (this.muted) {
           this.mute();
         } else {
           this.unmute();
         }

          if (self.cachedStartTimeSeconds){
            self.setTime(self.cachedStartTimeSeconds);
            self.cachedStartTimeSeconds = null;
          }

          return self;
        })
        .then(resolve)
        .catch(reject);
    });
  }

  public ensureSound(audioMedia: Object, sound?:Sound):Promise<Sound>{
    let self = this;
    return new Promise<Sound>((resolve, reject) => {
      if (!sound){
        self.createSoundFromAudioMedia(audioMedia)
          .then(resolve)
          .catch(reject)
      }else {
        resolve(sound);
      }
    });
  }

  public createSoundFromAudioMedia(audioMedia: Object):Promise<Sound>{
    /**
     * szedjük össze az összes source url-t
     */
    let sourceUrls = new Array<string>();
    audioMedia['sources'].forEach(function(source){
      if (source && source['url']){
        if (source["mime_type"] && source["mime_type"] == "audio/mp3"){
          /**
           * ha mp3 fájlunk lenne, akkor azt előre rakjuk mindig, hogy ha
           * egy böngésző le tudja azt játszani, akkor azt használja elsődlegesen
           */
          sourceUrls.unshift(source["url"]);
        }

        sourceUrls.push(source['url']);
      }
    });

    let sound = new Sound(sourceUrls, {
      preload: true,
      autoplay: false,
      loop: false,
      webAudioApi: true,
      crossOrigin: true,
    });

    return new Promise<Sound>((res, rej) => {
      sound.bind("canplay", function(){
        return res(sound);
      });
      sound.bind("error", function(e){
        console.error("canplay error",
            sound.getErrorCode(),sound.getStateCode(),sound.getNetworkStateCode(),
            sound.getErrorMessage(),sound.getStateMessage(),sound.getNetworkStateMessage(),
        e)
        rej(e);
      })
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/preview/preview-render-component/storyboard-renderer-audio.service.ts